<template>
  <div :id="printerId || 'printerDiv2'" class="is-preview-hidden">

    <div v-for="i in (localCopyCount || printCopyCount || 1)" :key="i" class="pr-container" :class="{'pr-page-break': i < (localCopyCount || printCopyCount || 1)}">
      <div class="pr-header">
        <div class="pr-branch">{{ branchLabel }}</div>
        <div class="pr-meta-row" :style="!(localIsFinal || isFinal) ? 'justify-content: flex-end;' : ''">
          <span v-if="localIsFinal || isFinal" class="pr-bill-num">Fiş No: {{ localBillNo || billId || billNo }}</span>
          <span class="pr-date-info">{{ localDateTime || currentDateTime }}</span>
        </div>
        <div v-if="(localNote || note) && (localNote || note).trim()" class="pr-header-note">
           <strong>Not:</strong> {{ localNote || note }}
        </div>
        <div v-if="(localCustomerName || customerName) && (localCustomerName || customerName).trim()" class="pr-header-note">
           <strong>Ad:</strong> {{ localCustomerName || customerName }}
        </div>
        <div class="pr-meta pr-meta-user">Personel: {{ localActivePersonal || activePersonal }}</div>
      </div>

    
    <div class="pr-sep"></div>

    <table class="pr-tbl">
      <thead>
        <tr>
          <th class="pr-th pr-al pr-c-name">Ürün</th>
          <th class="pr-th pr-ac pr-c-qty">Miktar</th>
          <th class="pr-th pr-ar pr-c-price">Tutar</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="entry in (localOrderEntries || orderEntries)" :key="entry.id" class="pr-item-row">
          <td class="pr-td pr-al pr-c-name">
            <span class="pr-product-name">{{ cleanProductName(entry.productName) }}</span>
            <span v-for="variant in entry.variantItems" :key="'v'+variant.id" class="pr-sub pr-block">* {{ variant.name }}</span>
            <template v-if="(entry.recipe && (entry.recipe.steps || entry.recipe.Steps)) || (entry.Recipe && (entry.Recipe.steps || entry.Recipe.Steps))">
              <span v-for="step in ((entry.recipe && (entry.recipe.steps || entry.recipe.Steps)) || (entry.Recipe && (entry.Recipe.steps || entry.Recipe.Steps)) || []).filter(x => x.isRemoved || x.IsRemoved || (x.selected && !x.isDefault) || (x.Selected && !x.IsDefault) || ((x.name || x.Name) && (x.name || x.Name).includes('Vanilya')))" :key="'s'+step.id" class="pr-sub pr-block" :class="{'pr-line-through': step.isRemoved || step.IsRemoved}">
                {{ (step.isRemoved || step.IsRemoved) ? '-' : '*' }} {{ (step.name || step.Name || (step.rawMaterial && step.rawMaterial.name) || (step.rawMaterial && step.rawMaterial.Name) || (step.rawmaterial && step.rawmaterial.name) || (step.rawmaterial && step.rawmaterial.Name) || (step.productName) || (step.product && step.product.name) || '').trim() }}
              </span>
            </template>
            <template v-for="extra in (entry.extras || [])">
              <span v-if="(Number(extra.quantity) || 0) > 0 && (!extra.variants || extra.variants.length === 0)" :key="'e'+extra.id" class="pr-sub pr-block">
                + {{ extra.name }} (x{{ extra.quantity }})
              </span>
              <template v-else-if="extra.variants && extra.variants.length > 0">
                <span v-for="variant in extra.variants.filter(v => (Number(v.quantity) || 0) > 0)" :key="'ev'+variant.id" class="pr-sub pr-block">
                  + {{ variant.name }} (x{{ variant.quantity }})
                </span>
              </template>
            </template>
            <span v-if="entry.note" class="pr-note pr-block">Not: {{ entry.note }}</span>
          </td>
          <td class="pr-td pr-ac pr-c-qty">
            <span class="pr-qty-badge">x{{ entry.productQuantity || entry.quantity || 1 }}</span>
          </td>
          <td class="pr-td pr-ar pr-c-price pr-price-cell">{{ $toCurrency(entry.originPrice || entry.OriginPrice || entry.price) }}</td>
        </tr>
      </tbody>
    </table>

    <div class="pr-sep pr-sep-thick"></div>
    <table class="pr-ftr-tbl">
      <tr>
        <td class="pr-ftr-lbl">Ara Toplam:</td>
        <td class="pr-ftr-val">
          {{ $toCurrency(
              Number(localTotalPrice !== null ? localTotalPrice : (totalPrice || 0)) + 
              Number(localTotalDiscountPrice !== null ? localTotalDiscountPrice : (totalDiscountPrice || 0))
          ) }}
        </td>
      </tr>
      <tr v-if="(localTotalDiscountPrice !== null ? localTotalDiscountPrice : (totalDiscountPrice || 0)) > 0" class="pr-discount">
        <td class="pr-ftr-lbl">İndirim:</td>
        <td class="pr-ftr-val">-{{ $toCurrency(localTotalDiscountPrice !== null ? localTotalDiscountPrice : (totalDiscountPrice || 0)) }}</td>
      </tr>
      <tr class="pr-ftr-net">
        <td class="pr-ftr-lbl">Ödenen Tutar:</td>
        <td class="pr-ftr-val">
          {{ $toCurrency(localTotalPrice !== null ? localTotalPrice : (totalPrice || 0)) }}
        </td>
      </tr>
    </table>
      <div class="pr-sep pr-sep-thin"></div>
      <div v-if="isFinal" class="pr-thanks">Bizi Tercih Ettiğiniz İçin Teşekkür Ederiz</div>
    </div>
  </div>
</template>


<script src="https://www.google.com/cloudprint/client/cpgadget.js"/>
<script>
import companyInfo from "../../../model/constants/companyInfo";
import printJS from "print-js";
import signalRService from "@/SignalRService";

const PRINT_CSS = `
  @page { size: 80mm auto; margin: 0; }
  @media print {
    body { margin: 0; padding: 0; background: #fff; }
    .pr-container { width: 80mm; padding: 10pt 6pt; box-sizing: border-box; color: #000; background: #fff; page-break-after: always; break-after: page; }
    .pr-container:last-child { page-break-after: auto; break-after: auto; }
  }
  body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; }
  .pr-container { width: 80mm; padding: 10pt 6pt; box-sizing: border-box; color: #000; background: #fff; }
  
  .pr-header { text-align: center; margin-bottom: 8pt; }
  .pr-branch { font-size: 11pt !important; font-weight: 900; margin-bottom: 8pt; text-transform: uppercase; letter-spacing: 1pt; }
  
  .pr-meta-row { display: flex; justify-content: space-between; align-items: center; margin: 4pt 0; padding-bottom: 2pt; }
  .pr-bill-num { font-size: 13pt !important; font-weight: 900;}
  .pr-date-info { font-size: 9pt !important; font-weight: 400; text-align: right; }
  .pr-header-note { font-size: 10pt !important; font-weight: bold; margin: 4pt 0; }

  .pr-meta { font-size: 9pt !important; line-height: 1.5; color: #000; }
  .pr-meta-user { margin-top: 2pt; font-size: 9pt !important; color: #000; }
  
  .pr-sep { border: 0; border-top: 1.5px dashed #000; margin: 4pt 0; display: block; }
  .pr-sep-thick { border-top: 2px solid #000 !important; margin-top: 2pt; margin-bottom: 4pt; }
  .pr-sep-thin { border-top: 1px solid #000 !important; margin-top: 4pt; margin-bottom: 4pt; }
  
  .pr-tbl { width: 100%; border-collapse: collapse; table-layout: fixed; margin-bottom: 4pt; }
  .pr-c-name { width: 55%; }
  .pr-c-qty { width: 15%; }
  .pr-c-price { width: 30%; }
  
  .pr-al { text-align: left; }
  .pr-ac { text-align: center; }
  .pr-ar { text-align: right; }
  
  .pr-th { font-size: 9pt !important; font-weight: bold; padding: 2pt 0 4pt; border-bottom: 1.5px solid #000; }
  .pr-td { vertical-align: middle; padding: 5pt 0; word-break: break-word; }
  
  .pr-item-row { border-bottom: 1px dashed #bbb; }
  .pr-item-row:last-child { border-bottom: none; }
  
  .pr-product-name { font-size: 9.5pt !important; font-weight: bold; display: block; }
  .pr-block { display: block; }
  .pr-sub { font-size: 7.5pt !important; color: #000; padding-left: 3pt; margin-top: 1.5pt; }
  .pr-note { font-size: 7.5pt !important; font-style: italic; color: #000; margin-top: 1.5pt; font-weight: bold; }
  
  .pr-qty-badge { font-weight: bold; font-size: 9.5pt !important; }
  .pr-price-cell { font-weight: 900; font-size: 10pt !important; white-space: nowrap; }
  
  .pr-ftr-tbl { width: 100%; border-collapse: collapse; }
  .pr-ftr-lbl { font-size: 10pt !important; font-weight: bold; text-align: left; padding: 2pt 0; white-space: nowrap; width: 50%; }
  .pr-ftr-val { font-size: 10pt !important; font-weight: bold; text-align: right; padding: 2pt 0; }
  .pr-ftr-net { border-top: 1.5px solid #000; }
  .pr-ftr-net .pr-ftr-lbl { font-size: 12pt !important; font-weight: 900; padding-top: 4pt; }
  .pr-ftr-net .pr-ftr-val { font-size: 13pt !important; font-weight: 900; padding-top: 4pt; }
  .pr-discount { color: #000; }
  
  .pr-thanks { text-align: center; font-size: 9pt !important; padding: 6pt 0 2pt; line-height: 1.6; font-weight: bold; }
  .pr-line-through { text-decoration: line-through !important; }
  .pr-note-area { font-size: 9pt !important; padding: 5pt 0; }
  .pr-meta-date { font-size: 8.5pt !important; }
`;

export default {
  props: {
    totalPrice: { type: Number, required: false },
    totalDiscountPrice: { type: Number, required: false },
    orderEntries: { type: Array, required: false },
    currentDateTime: { type: String, required: false },
    activePersonal: { type: String, required: false },
    branchName: { type: String, required: false },
    note: { type: String, required: false },
    customerName: { type: String, required: false, default: '' },
    billNo: { type: Number, required: false },
    printerId: { type: String, required: false, default: 'printerDiv2' },
    printCopyCount: { type: Number, required: false, default: 1 },
    isFinal: { type: Boolean, required: false, default: false },
    orderPayments: { type: Array, required: false, default: () => [] },
    connection: { type: Object, required: false, default: null },
    isKiosk: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      companyName: companyInfo.name,
      localOrderEntries: null,
      localTotalPrice: null,
      localTotalDiscountPrice: null,
      localActivePersonal: null,
      localBillNo: null,
      localNote: null,
      localCustomerName: null,
      localDateTime: null,
      localCopyCount: null,
      localIsFinal: null,
      localTotalPayedPrice: null,
      localLeftPrice: null,
      localTotalOriginPrice: null,
      localOrderPayments: null,
      localIsKiosk: false,
      isLoading: false
    }
  },
  computed: {
    billId() {
      return this.$store.getters["selfservice/getToLastBillId"];
    },
    branchLabel() {
      if (this.branchName) return this.branchName;
      const user = this.$store.getters["getActiveUser"];
      if (user && user.userBranch && user.userBranch !== 'Merkez') return user.userBranch;
      return this.companyName;
    },
    printerSettings() {
      return this.$store.getters["selfservice/getPrinterSettings"] || {};
    }
  },
  methods: {
    resetLocalData() {
      this.localOrderEntries = null;
      this.localTotalPrice = null;
      this.localTotalDiscountPrice = null;
      this.localActivePersonal = null;
      this.localBillNo = null;
      this.localNote = null;
      this.localCustomerName = null;
      this.localDateTime = null;
      this.localCopyCount = null;
      this.localIsFinal = null;
      this.localTotalPayedPrice = null;
      this.localOrderPayments = null;
      this.localLeftPrice = null;
      this.localIsKiosk = false;
    },
    setOrderAndPrint(data, count = null, isFinal = null, forceSignalR = false, forceBrowser = false) {
      this.resetLocalData();
      if (count !== null) this.localCopyCount = parseInt(count) || 1;
      if (isFinal !== null) this.localIsFinal = isFinal;
      
      if (data) {
        // v117 Fix: Farklı veri yapılarına (PascalCase/camelCase) karşı dayanıklılık
        const pData = data || {};
        this.localOrderEntries = pData.orderEntries || pData.entries || pData.Entries || [];
        this.localOrderPayments = pData.orderPayments || pData.payments || pData.Payments || [];
        this.localTotalPrice = pData.totalPrice !== undefined ? pData.totalPrice : (pData.TotalPrice !== undefined ? pData.TotalPrice : (this.totalPrice || 0));
        
        // v117.z Fix: hasBackendDiscounts tespiti (totalDiscountPrice alanını da dahil et)
        let discountVal = pData.totalDiscountPrice !== undefined ? pData.totalDiscountPrice : (pData.TotalDiscountPrice !== undefined ? pData.TotalDiscountPrice : (pData.discountPrice || null));
        const hasBackendDiscounts = (discountVal !== null && Number(discountVal) > 0);

        if (pData && !hasBackendDiscounts) {
           this.localTotalDiscountPrice = 0;
        } else {
           this.localTotalDiscountPrice = (discountVal !== null && Number(discountVal) > 0) ? Number(discountVal) : (this.totalDiscountPrice || 0);
        }

        // v118: 'Ara Toplam'ın her zaman tablodaki ürünlerin toplamı olması için manuel hesapla
        this.localTotalOriginPrice = this.localOrderEntries.reduce((total, entry) => {
            return total + (Number(entry.originPrice || entry.OriginPrice || entry.price) || 0);
        }, 0);

        // v118: 'Ödenen Tutar'ın her zaman (Ara Toplam - İndirim) olması için manuel hesapla
        this.localTotalPrice = Math.round((this.localTotalOriginPrice - this.localTotalDiscountPrice) * 100) / 100;

        this.localActivePersonal = pData.activePersonal || pData.ActivePersonal || '';
        this.localBillNo = pData.billNo || pData.BillNo || pData.id || pData.Id || 0;
        this.localDateTime = pData.currentDateTime || pData.CurrentDateTime || '';
        this.localNote = pData.note || pData.Note || '';
        this.localCustomerName = pData.customerName || pData.CustomerName || '';
        this.localIsKiosk = pData.isKiosk !== undefined ? pData.isKiosk : false;
        
        // v117 Fix: Ödenen tutar (Basit ve Kesin Çözüm)
        this.localTotalPayedPrice = this.localTotalPrice;




        // Backend'den gelen kesin bakiye (LeftPrice)
        const bLeft = pData.leftPrice !== undefined ? pData.leftPrice : (pData.LeftPrice !== undefined ? pData.LeftPrice : null);
        if (bLeft !== null) {
          this.localLeftPrice = Number(bLeft);
        } else {
          // Fallback bakiye hesabı
          this.localLeftPrice = Math.max(0, (this.localTotalPrice || 0) - this.localTotalPayedPrice);
        }
      }
      
      this.$nextTick(() => {
        this.printOrders(null, forceSignalR, forceBrowser);
      });
    },
    async printOrders(count = null, forceSignalR = false, forceBrowser = false) {
      if (count !== null) this.localCopyCount = parseInt(count) || 1;
      
      const pSettings = JSON.parse(localStorage.getItem('posSettings') || '{}');
      // Kiosk ise her halükarda SignalR zorla, değilse parametrelere göre karar ver
      // normal selfservice2 (masasız satış) ise sipariş tamamlanmasında forceBrowser = true gelir, forceSignalR = false gelir.
      // Eğer KIOSK ise, useSignalR her zaman true'dur!
      const useSignalR = this.isKiosk || forceSignalR || (!forceBrowser && pSettings.enable);

      const connectionToUse = this.connection || signalRService.connection;

      if (useSignalR && connectionToUse && connectionToUse.state === 'Connected') {
        try {
          const model = this.prepareModelForBackend();
          const copies = this.localCopyCount || 1;
          for (let i = 0; i < copies; i++) {
            await connectionToUse.invoke("PrintPayment", model);
          }
          console.log("[Printer2] SignalR yazdırma komutu başarıyla gönderildi.");
          
          // Eğer kiosk ise veya forceBrowser istenmemişse burada return edebiliriz.
          // Kiosk'ta asla Chrome yazdırma diyaloğu açılmamalıdır.
          if (this.isKiosk || !forceBrowser) {
            return;
          }
        } catch (err) {
          console.error("SignalR Print Error:", err);
          // Kiosk ekranındaysak hata olsa bile Chrome print ekranını açmamalıyız
          if (this.isKiosk) {
            this.$vs.notify({
              title: 'Yazdırma Hatası',
              text: 'Yazıcı servisine ulaşılamadı (SignalR).',
              color: 'danger'
            });
            return;
          }
        }
      }

      // Kiosk ekranından girilen siparişlerde Chrome yazdırma diyaloğu ASLA açılmamalı
      if (this.isKiosk) {
        console.warn("Kiosk ekranı: SignalR bağlantısı yok veya servis kapalı. Chrome yazdırma ekranı engellendi.");
        if (connectionToUse && connectionToUse.state !== 'Connected') {
           this.$vs.notify({
             title: 'Bağlantı Hatası',
             text: 'Yazıcı bağlantısı aktif değil (SignalR disconnected).',
             color: 'warning'
           });
        }
        return;
      }

      // Normal (kiosk dışı / selfservice2) siparişlerde tarayıcıdan yazdır
      try {
        this.$nextTick(() => {
          // Render için kısa bir gecikme (DOM ve resimlerin hazır olması için)
          setTimeout(() => {
            printJS({
              showModal: false,
              printable: this.printerId || 'printerDiv2',
              type: 'html',
              style: PRINT_CSS,
              scanStyles: false
            });
            console.log("print-js browser dialog triggered successfully.");
          }, 300);
        });
      } catch (e) {
        console.error("Yazdırma hatası:", e);
      }
    },
    prepareModelForBackend() {
      // v118.V31: Masa sistemindeki (Printer.vue) en güncel model yapısını kiosk için uyarla
      let cart = null;
      let finalOrderNo = Number(this.localBillNo || this.billId || 0);
      
      // v118.V34 [CRITICAL]: C# Int32 taşmasını önlemek için (Timestamp > 2.1B ise küçült)
      if (finalOrderNo > 2147483647) {
          console.warn("[Printer2] Order No is too large for Int32, truncating for SignalR binding safety.");
          finalOrderNo = finalOrderNo % 1000000000; // Son 9 hanesini al
      }

      // v118.V40: En kararlı yapı. Store'daki orijinal nesneyi bozma ve snapshot ile zenginleştir.
      cart = JSON.parse(JSON.stringify(this.$store.getters['selfservice/getCurrentCart'] || {}));
      
      if (this.localOrderEntries && this.localOrderEntries.length > 0) {
        cart.cartEntries = JSON.parse(JSON.stringify(this.localOrderEntries));
        cart.id = finalOrderNo;
        cart.realId = finalOrderNo;
        cart.orderNo = finalOrderNo;
        cart.OrderNo = finalOrderNo;
      } else {
        cart.id = finalOrderNo;
        cart.realId = finalOrderNo;
        cart.orderNo = finalOrderNo;
        cart.OrderNo = finalOrderNo;
      }
      
      // v118.V35: Masa adını 'KIOSK Sipariş' veya 'Hızlı Satış' yap
      const tableName = (this.localIsKiosk || this.isKiosk) ? 'KIOSK Sipariş' : 'Hızlı Satış';
      cart.name = tableName;
      cart.tableName = tableName;
      cart.TableName = tableName;
      cart.isAdisyon = !(this.localIsFinal !== null ? this.localIsFinal : this.isFinal);

      // Üst Bilgiler (Terminal App Görsel Uyumu İçin - PascalCase ve camelCase bir arada)
      cart.branchName = this.branchLabel;
      cart.BranchName = this.branchLabel;
      
      const safeCustomerName = (this.localCustomerName || cart.customerName || '').toString().trim();
      cart.customerName = safeCustomerName;
      cart.CustomerName = safeCustomerName;
      // v118.V41: Bazı terminal versiyonları nesne olarak bekleyebilir
      cart.customer = { name: safeCustomerName, Name: safeCustomerName };
      cart.Customer = { name: safeCustomerName, Name: safeCustomerName };
      
      const safeNote = (this.localNote || cart.note || '').toString().trim();
      cart.note = safeNote;
      cart.Note = safeNote;
      cart.OrderNote = safeNote;

      // v118.V46: Kullanıcı isteği üzerine 'Kiosk' ibaresiyle başlayıp yanına 'Ad' bilgisini ekliyoruz.
      let formattedTableName = "Kiosk";
      
      if (safeCustomerName) {
        formattedTableName += " | AD: " + safeCustomerName;
      }
      
      if (safeNote) {
        formattedTableName += " | NOT: " + safeNote;
      }

      // Ödeme Yöntemi Bilgilerini Al ve Ekle
      const safePayments = JSON.parse(JSON.stringify(this.localOrderPayments || this.orderPayments || []));
      cart.orderPayments = safePayments;
      cart.OrderPayments = safePayments;
      cart.paymentInformations = safePayments;
      cart.PaymentInformations = safePayments;
      
      cart.name = formattedTableName;
      cart.tableName = formattedTableName;
      cart.TableName = formattedTableName;
      
      // Personel kısmını temiz tutalım
      cart.UserName = this.localActivePersonal || this.activePersonal || (this.$store.state.AppActiveUser ? this.$store.state.AppActiveUser.name : "Kiosk");

      // Finansal mühürleme
      const totalGross = Number(this.localTotalOriginPrice !== null ? this.localTotalOriginPrice : (cart.totalOriginPrice || cart.totalPrice || 0));
      const totalDiscount = Number(this.localTotalDiscountPrice !== null ? this.localTotalDiscountPrice : (cart.totalDiscountPrice || 0));
      const totalNet = Number(this.localTotalPayedPrice !== null ? this.localTotalPayedPrice : (this.totalPrice !== undefined ? this.totalPrice : (cart.totalPayedPrice || 0)));
      const finalLeftPrice = Number(this.localLeftPrice !== null ? this.localLeftPrice : (totalGross - totalDiscount - totalNet));

      cart.totalOriginPrice = totalGross; 
      cart.totalDiscountPrice = totalDiscount;
      cart.totalPayedPrice = totalNet; 
      cart.totalPrice = totalNet; 
      cart.leftPrice = finalLeftPrice;
      cart.isKiosk = this.isKiosk || this.localIsKiosk;

      // v118.V36: [CRITICAL] Terminal App (C#) cartEntries içindeki her bir satırı tek tek bekler.
      const list = cart.cartEntries || [];
      list.forEach(entry => {
        entry.productName = this.cleanProductName(entry.productName || "");
        
        // Birim Fiyat Düzeltmesi
        const qty = parseFloat(entry.productQuantity || entry.quantity || 1);
        if (qty > 0) {
           entry.price = (parseFloat(entry.price) || 0) / qty;
           if (entry.originPrice) entry.originPrice = (parseFloat(entry.originPrice) || 0) / qty;
        }

        // Extras İzolasyonu (Printer.vue L411-428 ile aynı)
        if (entry.extras || entry.Extras) {
          const rawExtras = JSON.parse(JSON.stringify(entry.extras || entry.Extras || []));
          const filteredExtras = [];
          rawExtras.forEach(ex => {
            const eqty = parseFloat(ex.quantity || ex.Quantity || 0);
            const evariants = ex.variants || ex.Variants || [];
            if (eqty > 0 && evariants.length === 0) {
              filteredExtras.push(ex);
            } else if (evariants.length > 0) {
              const vFiltered = evariants.filter(v => parseFloat(v.quantity || v.Quantity || 0) > 0);
              if (vFiltered.length > 0) {
                ex.variants = vFiltered;
                ex.Variants = vFiltered;
                filteredExtras.push(ex);
              }
            }
          });
          entry.extras = filteredExtras;
          entry.Extras = filteredExtras;
        }
      });

      const user = this.$store.getters["getActiveUser"];
      cart.branchId = Number(cart.branchId || (user && user.branch ? user.branch.id : 0));
      cart.UserName = this.localActivePersonal || this.activePersonal || (user ? user.name : "Sistem");

      // Yazıcı Ayarları
      cart.printerName = this.printerSettings.mainPrinterName;
      cart.printerActive = this.printerSettings.enable;

      // Temizlik
      delete cart.entries;
      delete cart.Entries;

      console.log("[Printer2] Final Model Prepared for SignalR:", JSON.parse(JSON.stringify(cart)));
      return cart;
    },
    cleanProductName(name) {
      if (!name) return '';
      let n = name.replace(/\s\d{2}:\d{2}$/, '');
      let separator = n.includes('->') ? '->' : (n.includes('>') ? '>' : null);
      
      if (separator) {
        const parts = n.split(separator).map(s => s.trim());
        const main = parts[0];
        // Filter out 'Adet' or parts that just repeat the main product name
        const filteredParts = parts.filter((part, index) => {
          if (index === 0) return true;
          const p = part.toLowerCase();
          return p !== 'adet' && !main.toLowerCase().includes(p) && !p.includes(main.toLowerCase());
        });
        return filteredParts.join('->');
      }
      return n;
    },
  }
}
</script>

<style>
.pr-container { 
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; 
  width: 80mm; 
  margin: 20px auto; 
  padding: 10pt 6pt; 
  box-sizing: border-box; 
  color: #000; 
  background: #fff;
  border: 1px solid #ddd; 
  box-shadow: 0 4px 12px rgba(0,0,0,0.15); 
}

.pr-header { text-align: center; margin-bottom: 8pt; }
.pr-branch { font-size: 15pt !important; font-weight: 900; margin-bottom: 10pt; text-transform: uppercase; letter-spacing: 1.2pt; border-bottom: 3px solid #000; padding-bottom: 5pt; }

.pr-meta-row { display: flex; justify-content: space-between; align-items: center; margin: 6pt 0; padding-bottom: 3pt; }
.pr-bill-num { font-size: 14pt !important; font-weight: 900; border: 2px solid #000; padding: 3px 8px; }
.pr-date-info { font-size: 10pt !important; font-weight: 400; text-align: right; }
.pr-header-note { font-size: 11pt !important; font-weight: bold; margin: 6pt 0; }

.pr-meta { font-size: 9pt !important; line-height: 1.5; color: #000; }
.pr-meta-user { margin-top: 2pt; font-size: 9pt !important; color: #000; }

.pr-sep { border: 0; border-top: 1.5px dashed #000; margin: 4pt 0; display: block; }
.pr-sep-thick { border-top: 2px solid #000 !important; margin-top: 2pt; margin-bottom: 4pt; }
.pr-sep-thin  { border-top: 1px solid #000 !important; margin-top: 4pt; margin-bottom: 4pt; }

.pr-tbl { width: 100%; border-collapse: collapse; table-layout: fixed; margin-bottom: 4pt; }
.pr-c-name  { width: 55%; }
.pr-c-qty   { width: 15%; }
.pr-c-price { width: 30%; }

.pr-al { text-align: left; }
.pr-ac { text-align: center; }
.pr-ar { text-align: right; }

.pr-th { font-size: 9pt !important; font-weight: bold; padding: 2pt 0 4pt; border-bottom: 1.5px solid #000; }
.pr-td { vertical-align: middle; padding: 5pt 0; word-break: break-word; }

.pr-item-row { border-bottom: 1px dashed #bbb; }
.pr-item-row:last-child { border-bottom: none; }

.pr-product-name { font-size: 9.5pt !important; font-weight: bold; display: block; }
.pr-block { display: block; }
.pr-sub  { font-size: 7.5pt !important; color: #000; padding-left: 3pt; margin-top: 1.5pt; }
.pr-note { font-size: 7.5pt !important; font-style: italic; color: #000; margin-top: 1.5pt; font-weight: bold; }

.pr-qty-badge { font-weight: bold; font-size: 9.5pt !important; }
.pr-price-cell { font-weight: 900; font-size: 10pt !important; white-space: nowrap; }

.pr-ftr-tbl { width: 100%; border-collapse: collapse; }
.pr-ftr-lbl { font-size: 10pt !important; font-weight: bold; text-align: left; padding: 2pt 0; white-space: nowrap; width: 50%; }
.pr-ftr-val { font-size: 10pt !important; font-weight: bold; text-align: right; padding: 2pt 0; }
.pr-ftr-net { border-top: 2px solid #000; }
.pr-ftr-net .pr-ftr-lbl { font-size: 12pt !important; font-weight: 900; padding-top: 4pt; }
.pr-ftr-net .pr-ftr-val { font-size: 13pt !important; font-weight: 900; padding-top: 4pt; }
.pr-discount { color: #000; }

.pr-thanks  { text-align: center; font-size: 9pt !important; padding: 6pt 0 2pt; line-height: 1.6; font-weight: bold; }
.pr-note-area { font-size: 9pt !important; padding: 5pt 0; }
.pr-meta-date { font-size: 8.5pt !important; text-align: center; width: 100%; }

/* Hide preview for Kiosk */
.is-preview-hidden {
  position: fixed !important;
  top: -9999px !important;
  left: -9999px !important;
  opacity: 0 !important;
  pointer-events: none !important;
  z-index: -1000 !important;
}
</style>
